import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach token from localStorage (fallback when cookies blocked)
api.interceptors.request.use((config) => {
    const token = typeof window !== "undefined" ? localStorage.getItem("dr_token") : null;
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Something went wrong.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    if (typeof d?.msg === "string") return d.msg;
    return String(d);
}
